import JSZip from 'jszip'

export const isFolderDrop = (files) => {
  if (!files || files.length === 0) return false

  return files.some((file) => {
    const path = file.path || file.webkitRelativePath || ''
    return path.startsWith('/') || path.includes('/')
  })
}

export const getFolderName = (files) => {
  if (!files || files.length === 0) return 'folder'

  const path = files[0].path || files[0].webkitRelativePath || ''
  if (!path) return 'folder'

  const parts = path.split('/')
  if (path.startsWith('/')) {
    return parts[1] || 'folder'
  }
  return parts[0] || 'folder'
}

export const zipFolderFiles = async (files) => {
  const zip = new JSZip()
  const folderName = getFolderName(files)

  files.forEach((file) => {
    const filePath = file.path || file.webkitRelativePath || file.name
    const zipPath = filePath.startsWith('/') ? filePath.substring(1) : filePath
    zip.file(zipPath, file)
  })

  const content = await zip.generateAsync({ type: 'blob' })

  const zipFile = new File([content], `${folderName}.zip`, {
    type: 'application/zip',
    lastModified: new Date()
  })

  zipFile.isFolder = true
  zipFile.folderName = folderName

  return zipFile
}

export const createMockFolderFile = (files) => {
  if (!files || files.length === 0) return null

  const folderName = getFolderName(files)

  const totalSize = files.reduce((acc, file) => acc + file.size, 0)

  const mockFile = {
    name: `${folderName}.zip`,
    size: totalSize,
    type: 'application/zip',
    isRawFolder: true,
    isFolder: true,
    folderName: folderName,
    lastModified: Date.now(),
    lastModifiedDate: new Date(),
    slice: () => new Blob(),
    rawFiles: files.map((f) => ({
      file: f,
      relativePath: f.path || f.webkitRelativePath
    }))
  }

  return mockFile
}

export const zipFolderFilesWithWorker = (mockFile) => {
  return new Promise((resolve, reject) => {
    const worker = new Worker(new URL('./zip.worker.js', import.meta.url))

    worker.onmessage = (e) => {
      const { success, zipFile, error } = e.data
      if (success) {
        resolve(zipFile)
      } else {
        reject(new Error(error))
      }
      worker.terminate()
    }

    worker.onerror = (error) => {
      reject(error)
      worker.terminate()
    }

    // Send files to worker
    worker.postMessage({
      files: mockFile.rawFiles,
      folderName: mockFile.folderName
    })
  })
}
